export function sendEventToDataLayer(eventName, params = {}) {
  try {
    if (typeof window === 'undefined') return;
    if (!eventName || typeof eventName !== 'string') return;

    window.dataLayer = window.dataLayer || [];
    const payload = {
      event: 'custom_event',
      eventCategory: eventName,
      btnLabel: params.btn_label,
      moduleName: params.module,
    };
    window.dataLayer.push(payload);
  } catch (_) {}
}

export function initializeGoogleTagManager() {
  try {
    const gtmContainerId = process.env.REACT_APP_GTM_ID;
    if (!gtmContainerId) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const firstScriptTag = document.getElementsByTagName('script')[0];
    const gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmContainerId)}`;
    firstScriptTag.parentNode.insertBefore(gtmScript, firstScriptTag);

    function insertNoScript() {
      try {
        const noscript = document.createElement('noscript');
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(gtmContainerId)}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        noscript.appendChild(iframe);
        if (document.body && document.body.firstChild) {
          document.body.insertBefore(noscript, document.body.firstChild);
        } else if (document.body) {
          document.body.appendChild(noscript);
        }
      } catch (_) {}
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', insertNoScript);
    } else {
      insertNoScript();
    }
  } catch (_) {}
}
